<ng-template #template>
    <div class="modal-header">
        <h5 class="modal-title">{{ dom_elements['title'] }} fermo tecnico - {{vehicle.plate}} </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">Richiedi da</span>
            </div>
            <input type="text"
                   class="form-control"
                   style="height: auto;"
                   #dp="bsDatepicker"
                   bsDatepicker
                   [bsConfig]="{dateInputFormat: 'D/MM/YYYY', showWeekNumbers: false}"
                   [(bsValue)]="technicalShutdown._from"
            >

            <timepicker [(ngModel)]="technicalShutdown._from"
                        [showMeridian]="false">

            </timepicker>
        </div>
        <div class="form-group">
            <label for="motivazione">Definisci fine fermo</label>
            <input type="checkbox" aria-label="Definisci fine fermo"
                   (change)="resetTo()"
                   [(ngModel)]="dom_elements.known_to">
        </div>
        <div class="input-group mb-3" *ngIf="dom_elements.known_to">
            <div class="input-group-prepend">
                <span class="input-group-text">Richiedi a</span>
            </div>
            <input type="text"
                   class="form-control"
                   style="height: auto;"
                   #dp="bsDatepicker"
                   bsDatepicker
                   [minDate]="technicalShutdown._from"
                   [bsConfig]="{dateInputFormat: 'D/MM/YYYY', showWeekNumbers: false}"
                   [(bsValue)]="technicalShutdown.to"
            >

            <timepicker [(ngModel)]="technicalShutdown.to"
                        [showMeridian]="false">

            </timepicker>


        </div>

        <div class="form-group">
            <label for="motivazione">Motivazione - Luogo</label>
            <textarea class="form-control height250"  id="motivazione"
                      [(ngModel)]="technicalShutdown.motivation" maxlength="250"></textarea>
        </div>

    </div>

    <div classs="modal-footer">
        <button type="button" class="btn btn-success" (click)="create()" style="margin:1em;">
            Salva
        </button>
    </div>
</ng-template>
